import { defineComponent as g, computed as b, openBlock as t, createBlock as s, withCtx as y, createVNode as i, unref as a, createElementBlock as o, normalizeClass as h, toDisplayString as l, createCommentVNode as r } from "vue";
import { RevButtonIcon as k } from "@ds/components/ButtonIcon";
import w from "../../../icons/generated/IconCross.vue2.js";
import v from "../../../icons/generated/IconWarning.vue2.js";
import { tw as m } from "../../../utils/tailwind.js";
import x from "./DocumentLabelWrapper.vue2.js";
import B from "./DocumentName.vue2.js";
const C = {
  key: 0,
  class: "text-static-danger-hi caption-bold truncate"
}, M = {
  key: 1,
  class: "text-static-danger-hi grow truncate py-8"
}, z = /* @__PURE__ */ g({
  name: "DocumentError",
  __name: "DocumentError",
  props: {
    name: {},
    errorMessage: {},
    deletable: { type: Boolean },
    deleteButtonAriaLabel: {}
  },
  emits: ["delete"],
  setup(e, { emit: c }) {
    const d = e, u = c, f = b(() => [
      m`ml-0 grow overflow-hidden`,
      !d.errorMessage && m`py-8`
    ]);
    return ($, n) => (t(), s(x, { class: "border-static-danger-hi flex w-full grow items-center justify-between border" }, {
      default: y(() => [
        i(a(v), { class: "text-static-danger-hi" }),
        e.name ? (t(), o("div", {
          key: 0,
          class: h(f.value)
        }, [
          i(B, { name: e.name }, null, 8, ["name"]),
          e.errorMessage ? (t(), o("div", C, l(e.errorMessage), 1)) : r("", !0)
        ], 2)) : r("", !0),
        !e.name && e.errorMessage ? (t(), o("span", M, l(e.errorMessage), 1)) : r("", !0),
        e.deletable ? (t(), s(a(k), {
          key: 2,
          "aria-label": e.deleteButtonAriaLabel,
          icon: a(w),
          variant: "ghost",
          onClick: n[0] || (n[0] = (p) => u("delete"))
        }, null, 8, ["aria-label", "icon"])) : r("", !0)
      ]),
      _: 1
    }));
  }
});
export {
  z as default
};
